module.exports = __webpack_public_path__ + "img/lj3.c17af731.png";